let defaultAttributes = [
	{
		key: "data-pcoplus-widget",
		name: "Widget Type",
		value: "groups",
		type: "noEdit",
		group: null,
		hidden: true,
	},
	{
		key: "data-church-center-url",
		name: "Church Center URL",
		value: "",
		type: "noEdit",
		group: null,
		hidden: true,
	},
	{
		key: "data-filter-type",
		name: "Filter By Group Type",
		value: "",
		type: "group-type",
		group: "Functionality",
	},

	{
		key: "data-filter-type-mode",
		name: "Group Type Filter Mode",
		value: "Any",
		group: "Functionality",
		type: "noEdit",
		condition: { "data-filter-type": "valued" },
		hidden: true,
		options: [
			// { name: "Match All", value: "All" },
			{ name: "Match Any", value: "Any" },
		],
	},

	{
		key: "data-filter-tags",
		name: "Filter By Tag Name",

		value: "",
		type: "group-tags",
		group: "Functionality",
	},

	{
		key: "data-filter-tags-mode",
		name: "Tag Filter Mode",
		value: "Any",
		group: "Functionality",
		type: "select",
		condition: { "data-filter-tags": { method: "contains", value: "," } },
		options: [
			{ name: "Match All", value: "All" },
			{ name: "Match Any", value: "Any" },
		],
	},

	{
		key: "data-caption-join",
		name: "Join",
		value: "Request to join",
		type: "text",
		group: "Language",
	},
	{
		key: "data-caption-more-information",
		name: "More Information",
		value: "Learn more",
		type: "text",
		group: "Language",
	},
	{
		key: "data-caption-close",
		name: "Close Button",
		value: "Close",
		type: "text",
		group: "Language",
	},

	{
		key: "data-pcoplus-key",
		name: "PCO Chef API Key",
		value: "",
		type: "noEdit",
		group: null,
		hidden: true,
		required: true,
	},

	{
		key: "data-show-filters",
		name: "Show Filters",
		value: true,
		type: "boolean",
		group: "Functionality",
	},

	{
		key: "data-hide-location",
		name: "Hide Location",
		value: true,
		type: "boolean",
		group: "Functionality",
	},

	{
		key: "data-use-modals",
		name: "Use Modals",
		value: true,
		type: "boolean",
		group: "Functionality",
	},
	{
		key: "data-hide-tags",
		name: "Hide Tags",
		value: false,
		type: "boolean",
		group: "Functionality",
	},
	{
		key: "data-limit",
		name: "Limit",
		value: 100,
		type: "number",
		group: "Functionality",
		range: [1, 100],
		condition: { "data-grouped": false },
	},
	{
		key: "data-corner-radius",
		name: "Rounded Edge Radius",
		help: "(in points)",
		value: 4,
		type: "number",
		group: "Style",
		range: [0, 32],
	},

	{
		key: "data-image-shape",
		name: "Image Shape",
		value: "cinematic",
		group: "Style",
		type: "select",
		options: [
			{ name: "Cinematic (16:9)", value: "cinematic" },
			{ name: "Square (1:1)", value: "square" },
		],
	},

	// {
	// 	key: "data-dark-mode",
	// 	name: "Dark Mode",
	// 	value: false,
	// 	type: "boolean",
	// 	group: "Style",
	// },

	{
		key: "data-brand-color",
		name: "Brand Color",
		value: "#FF7461",
		group: "Style",
		type: "color",
	},
	{
		key: "data-button-color",
		name: "Button Color",
		value: "#4EA0CF",
		group: "Style",
		type: "color",
	},

	{
		key: "data-modal-color",
		name: "Modal Color",
		value: "#FFFFFF",
		group: "Style",
		type: "color",
	},

	{
		key: "data-text-color",
		name: "Text Color",
		value: "#333333",
		group: "Style",
		determineDarkMode: true,
		type: "color",
	},
];

export default defaultAttributes;
